if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      constructor() {
        super();

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          grabCursor: false,
          allowTouchMove: true,
          autoHeight: true,

          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },

          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
            type: 'fraction',
          },
        };
      }

      connectedCallback() {
        const slider = this.querySelector('.swiper');

        if (!slider) return;

        this.addNo2moroStyles();

        this.formatCards();

        slider.style.paddingBottom = '2px';
        slider.style.boxSizing = 'border-box';

        this.sliderInstance = new window.FoxTheme.Carousel(
          slider,
          this.sliderOptions
        );

        this.sliderInstance.init();

        this.fixQuickviewDuplicate();

        requestAnimationFrame(() => {
          window.dispatchEvent(new Event('resize'));
        });

        window.setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        }, 250);
      }

      formatCards() {
        const cards = this.querySelectorAll('.product-card--list');

        cards.forEach((card) => {
          if (card.classList.contains('nm-wiw-card-ready')) return;

          const originalWrapper = card.querySelector(
            '.product-card__wrapper'
          );

          if (!originalWrapper) return;

          const imageWrapper = originalWrapper.querySelector(
            '.product-card__image-wrapper'
          );

          const info = originalWrapper.querySelector(
            '.product-card__info'
          );

          if (!imageWrapper || !info) return;

          const title = info.querySelector(
            '.product-card__title'
          );

          const price =
            info.querySelector('.f-price') ||
            info.querySelector('.price');

          const actionButton = info.querySelector(
            '.product-card__action-button'
          );

          let action = null;

          if (actionButton) {
            const productForm = actionButton.closest('form');

            if (productForm && info.contains(productForm)) {
              action = productForm;
            } else {
              action = actionButton;
            }
          }

          const row = document.createElement('div');
          row.className = 'nm-wiw-row';

          const imageCell = document.createElement('div');
          imageCell.className = 'nm-wiw-row__image';

          const middleCell = document.createElement('div');
          middleCell.className = 'nm-wiw-row__middle';

          const actionCell = document.createElement('div');
          actionCell.className = 'nm-wiw-row__action';

          imageCell.appendChild(imageWrapper);

          if (title) {
            middleCell.appendChild(title);
          }

          if (price) {
            middleCell.appendChild(price);
          }

          if (action) {
            actionCell.appendChild(action);
          }

          row.appendChild(imageCell);
          row.appendChild(middleCell);
          row.appendChild(actionCell);

          originalWrapper.replaceWith(row);

          card.classList.add('nm-wiw-card-ready');
        });
      }

      addNo2moroStyles() {
        const existing = document.getElementById(
          'nm-wiw-row-styles'
        );

        if (existing) {
          existing.remove();
        }

        const style = document.createElement('style');

        style.id = 'nm-wiw-row-styles';

        style.textContent = `

          .complementary-products {
            width: 100%;
            min-width: 0;
          }

          .complementary-products .swiper {
            width: 100%;
            min-width: 0;
            overflow: hidden;
          }

          .complementary-products .swiper-slide {
            height: auto !important;
            min-width: 0;
          }

          .complementary-products
          .nm-wiw-card-ready {
            width: 100% !important;
            min-width: 0 !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: hidden !important;
          }

          .nm-wiw-row {
            display: grid !important;

            grid-template-columns:
              74px
              minmax(0, 1fr)
              44px !important;

            align-items: center !important;

            gap: 12px !important;

            width: 100% !important;
            min-width: 0 !important;

            min-height: 96px !important;

            padding: 9px 12px !important;

            margin: 0 !important;

            box-sizing: border-box !important;
          }

          /* IMAGE — LEFT */

          .nm-wiw-row__image {
            display: flex !important;

            align-items: center !important;
            justify-content: center !important;

            width: 74px !important;
            min-width: 74px !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          .nm-wiw-row__image
          .product-card__image-wrapper {
            position: relative !important;

            display: block !important;

            width: 74px !important;
            min-width: 74px !important;
            max-width: 74px !important;

            height: 78px !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;

            border-radius: 10px !important;
          }

          .nm-wiw-row__image
          .product-card__image-wrapper > a {
            display: block !important;

            width: 100% !important;
            height: 100% !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;

            border-radius: 10px !important;
          }

          .nm-wiw-row__image
          .product-card__image {
            position: relative !important;

            display: block !important;

            width: 100% !important;
            height: 100% !important;

            min-height: 0 !important;

            margin: 0 !important;
            padding: 0 !important;

            aspect-ratio: auto !important;

            --aspect-ratio: auto !important;

            overflow: hidden !important;

            border-radius: 10px !important;
          }

          .nm-wiw-row__image
          .product-card__image::before {
            display: none !important;
          }

          .nm-wiw-row__image
          .product-card__image img {
            position: static !important;

            display: block !important;

            inset: auto !important;

            width: 100% !important;
            height: 100% !important;

            max-width: none !important;

            margin: 0 !important;

            object-fit: cover !important;
            object-position: center !important;

            border-radius: 10px !important;
          }

          /* PRODUCT NAME + PRICE — MIDDLE */

          .nm-wiw-row__middle {
            display: flex !important;

            flex-direction: column !important;

            align-items: flex-start !important;
            justify-content: center !important;

            gap: 4px !important;

            min-width: 0 !important;

            margin: 0 !important;
            padding: 0 !important;

            text-align: left !important;
          }

          .nm-wiw-row__middle
          .product-card__title {
            width: 100% !important;
            min-width: 0 !important;

            margin: 0 !important;
            padding: 0 !important;

            font-size: 14px !important;
            line-height: 1.3 !important;

            text-align: left !important;
          }

          .nm-wiw-row__middle
          .product-card__title a {
            display: -webkit-box !important;

            width: 100% !important;

            overflow: hidden !important;

            text-align: left !important;

            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          .nm-wiw-row__middle
          .f-price,

          .nm-wiw-row__middle
          .price {
            margin: 0 !important;
            padding: 0 !important;

            text-align: left !important;
          }

          /* BAG — RIGHT */

          .nm-wiw-row__action {
            display: flex !important;

            align-items: center !important;
            justify-content: center !important;

            width: 44px !important;
            min-width: 44px !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          .nm-wiw-row__action form {
            display: block !important;

            width: 44px !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          .nm-wiw-row__action
          .product-card__action-button {
            position: static !important;

            top: auto !important;
            right: auto !important;
            bottom: auto !important;
            left: auto !important;

            inset: auto !important;

            transform: none !important;

            display: flex !important;

            align-items: center !important;
            justify-content: center !important;

            width: 44px !important;
            min-width: 44px !important;
            max-width: 44px !important;

            height: 44px !important;
            min-height: 44px !important;
            max-height: 44px !important;

            margin: 0 !important;
            padding: 0 !important;

            border-radius: 8px !important;
          }

          .nm-wiw-row__action
          .product-card__atc-icon {
            display: flex !important;

            align-items: center !important;
            justify-content: center !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          /* MOBILE */

          @media (max-width: 767.98px) {

            .nm-wiw-row {
              grid-template-columns:
                58px
                minmax(0, 1fr)
                40px !important;

              gap: 9px !important;

              min-height: 82px !important;

              padding: 7px 9px !important;
            }

            .nm-wiw-row__image {
              width: 58px !important;
              min-width: 58px !important;
            }

            .nm-wiw-row__image
            .product-card__image-wrapper {
              width: 58px !important;
              min-width: 58px !important;
              max-width: 58px !important;

              height: 66px !important;

              border-radius: 9px !important;
            }

            .nm-wiw-row__image
            .product-card__image-wrapper > a,

            .nm-wiw-row__image
            .product-card__image,

            .nm-wiw-row__image
            .product-card__image img {
              border-radius: 9px !important;
            }

            .nm-wiw-row__middle
            .product-card__title {
              font-size: 13px !important;
            }

            .nm-wiw-row__action {
              width: 40px !important;
              min-width: 40px !important;
            }

            .nm-wiw-row__action form {
              width: 40px !important;
            }

            .nm-wiw-row__action
            .product-card__action-button {
              width: 40px !important;
              min-width: 40px !important;
              max-width: 40px !important;

              height: 40px !important;
              min-height: 40px !important;
              max-height: 40px !important;
            }
          }
        `;

        document.head.appendChild(style);
      }

      fixQuickviewDuplicate() {
        const modalIds = [];

        Array.from(
          this.querySelectorAll('quick-view-modal')
        ).forEach((modal) => {
          const modalID = modal.getAttribute('id');

          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }
    }
  );
}